import { createSelector } from 'reselect';

export const selectMap = state => state.map;

export const selectDebug = createSelector(selectMap, map => map.debug);
export const selectTileJSON = createSelector(selectMap, map => map.tileJSON);
export const selectMapClass = createSelector(selectMap, map => map.className);
export const selectMapStyle = createSelector(selectMap, map => map.style);



// WEBPACK FOOTER //
// ./src/modules/map/selectors/base.js